export default __webpack_public_path__ + "static/media/nuovo-progetto_2x.26c472b4.png";